import { render, staticRenderFns } from "./base-menu.vue?vue&type=template&id=44afdf7b"
import script from "./base-menu.vue?vue&type=script&lang=js"
export * from "./base-menu.vue?vue&type=script&lang=js"
import style0 from "./base-menu.vue?vue&type=style&index=0&id=44afdf7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports